/* ==========================================================================
   WestPoint Home Bahrain — Sleep Profiler Quiz
   Vanilla JS — no frameworks. Bilingual AR/EN, RTL-aware.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- Language detection ---- */
  var root = document.getElementById('sleep-profiler-quiz');
  if (!root) return;
  var lang = root.getAttribute('data-lang') || document.documentElement.lang || 'en';
  var isAr = lang.indexOf('ar') === 0;
  function t(en, ar) { return isAr ? ar : en; }

  /* ---- SVG icons (inline) ---- */
  var icons = {
    side: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="36" width="56" height="8" rx="3" fill="#e8e4dd"/><rect x="4" y="28" width="18" height="12" rx="4" fill="#C4A265" opacity="0.6"/><ellipse cx="22" cy="28" rx="7" ry="7" fill="#2C3E50"/><path d="M22 35c4 0 8 2 10 6l8 3" stroke="#2C3E50" stroke-width="2.5" stroke-linecap="round"/><path d="M32 41c2 4 2 8-2 10" stroke="#2C3E50" stroke-width="2.5" stroke-linecap="round"/></svg>',
    back: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="36" width="56" height="8" rx="3" fill="#e8e4dd"/><rect x="22" y="26" width="20" height="14" rx="4" fill="#C4A265" opacity="0.6"/><ellipse cx="32" cy="26" rx="7" ry="7" fill="#2C3E50"/><line x1="32" y1="33" x2="32" y2="44" stroke="#2C3E50" stroke-width="2.5" stroke-linecap="round"/><line x1="24" y1="38" x2="40" y2="38" stroke="#2C3E50" stroke-width="2.5" stroke-linecap="round"/><path d="M28 44l-4 8M36 44l4 8" stroke="#2C3E50" stroke-width="2.5" stroke-linecap="round"/></svg>',
    stomach: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="36" width="56" height="8" rx="3" fill="#e8e4dd"/><rect x="4" y="28" width="18" height="12" rx="4" fill="#C4A265" opacity="0.6"/><ellipse cx="18" cy="30" rx="7" ry="6" fill="#2C3E50"/><path d="M18 36c6 0 14 1 22 1s14 1 16 3" stroke="#2C3E50" stroke-width="2.5" stroke-linecap="round"/><path d="M12 36l-4 8M48 40l4 6" stroke="#2C3E50" stroke-width="2.5" stroke-linecap="round"/></svg>',
    combo: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="36" width="56" height="8" rx="3" fill="#e8e4dd"/><rect x="10" y="28" width="16" height="12" rx="4" fill="#C4A265" opacity="0.6"/><ellipse cx="22" cy="28" rx="6" ry="6" fill="#2C3E50"/><path d="M22 34c4 1 8 3 12 4l10 2" stroke="#2C3E50" stroke-width="2.5" stroke-linecap="round"/><path d="M34 38l6 8M22 40l-4 6" stroke="#2C3E50" stroke-width="2.5" stroke-linecap="round"/><circle cx="50" cy="18" r="3" fill="#C4A265" opacity="0.4"/><path d="M47 18l6 0M50 15l0 6" stroke="#C4A265" stroke-width="1" opacity="0.5"/></svg>',
    hot: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="14" fill="#C4A265" opacity="0.2"/><circle cx="32" cy="32" r="8" fill="#C4A265"/><g stroke="#C4A265" stroke-width="2.5" stroke-linecap="round"><line x1="32" y1="8" x2="32" y2="14"/><line x1="32" y1="50" x2="32" y2="56"/><line x1="8" y1="32" x2="14" y2="32"/><line x1="50" y1="32" x2="56" y2="32"/><line x1="14.9" y1="14.9" x2="19.2" y2="19.2"/><line x1="44.8" y1="44.8" x2="49.1" y2="49.1"/><line x1="14.9" y1="49.1" x2="19.2" y2="44.8"/><line x1="44.8" y1="19.2" x2="49.1" y2="14.9"/></g></svg>',
    cold: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><g stroke="#0F3460" stroke-width="2" stroke-linecap="round"><line x1="32" y1="8" x2="32" y2="56"/><line x1="12" y1="22" x2="52" y2="42"/><line x1="12" y1="42" x2="52" y2="22"/><line x1="26" y1="12" x2="32" y2="18"/><line x1="38" y1="12" x2="32" y2="18"/><line x1="26" y1="52" x2="32" y2="46"/><line x1="38" y1="52" x2="32" y2="46"/></g><circle cx="32" cy="32" r="4" fill="#0F3460" opacity="0.3"/></svg>',
    neutral: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="12" y="22" width="40" height="20" rx="6" fill="#e8e4dd"/><rect x="16" y="26" width="14" height="12" rx="3" fill="#C4A265" opacity="0.4"/><rect x="34" y="26" width="14" height="12" rx="3" fill="#0F3460" opacity="0.3"/><line x1="31" y1="24" x2="31" y2="40" stroke="#ccc" stroke-width="1" stroke-dasharray="2 2"/></svg>',
    percale: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="14" width="44" height="36" rx="4" fill="#F8F6F3" stroke="#C4A265" stroke-width="1.5"/><g stroke="#C4A265" stroke-width="0.8" opacity="0.4"><line x1="10" y1="22" x2="54" y2="22"/><line x1="10" y1="30" x2="54" y2="30"/><line x1="10" y1="38" x2="54" y2="38"/></g><path d="M18 46c4-6 8-6 12 0s8 6 12 0" stroke="#C4A265" stroke-width="1.5" fill="none" opacity="0.6"/></svg>',
    sateen: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="14" width="44" height="36" rx="4" fill="#F8F6F3" stroke="#C4A265" stroke-width="1.5"/><defs><linearGradient id="sateenG" x1="10" y1="14" x2="54" y2="50"><stop offset="0%" stop-color="#C4A265" stop-opacity="0.1"/><stop offset="50%" stop-color="#C4A265" stop-opacity="0.25"/><stop offset="100%" stop-color="#C4A265" stop-opacity="0.05"/></linearGradient></defs><rect x="10" y="14" width="44" height="36" rx="4" fill="url(#sateenG)"/></svg>',
    cozy: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="14" width="44" height="36" rx="4" fill="#F8F6F3" stroke="#C4A265" stroke-width="1.5"/><g stroke="#C4A265" stroke-width="1" opacity="0.35"><path d="M14 18c2 2 4 2 6 0s4-2 6 0 4 2 6 0 4-2 6 0 4 2 6 0 4-2 6 0"/><path d="M14 26c2 2 4 2 6 0s4-2 6 0 4 2 6 0 4-2 6 0 4 2 6 0 4-2 6 0"/><path d="M14 34c2 2 4 2 6 0s4-2 6 0 4 2 6 0 4-2 6 0 4 2 6 0 4-2 6 0"/><path d="M14 42c2 2 4 2 6 0s4-2 6 0 4 2 6 0 4-2 6 0 4 2 6 0 4-2 6 0"/></g></svg>',
    modern: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="12" y="16" width="40" height="32" rx="2" fill="#F8F6F3" stroke="#2C3E50" stroke-width="1.5"/><rect x="16" y="20" width="16" height="12" rx="1" fill="#e8e4dd"/><rect x="36" y="20" width="12" height="12" rx="1" fill="#C4A265" opacity="0.3"/><line x1="16" y1="38" x2="48" y2="38" stroke="#2C3E50" stroke-width="1" opacity="0.3"/><line x1="16" y1="42" x2="36" y2="42" stroke="#2C3E50" stroke-width="1" opacity="0.2"/></svg>',
    classic: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="12" y="16" width="40" height="32" rx="3" fill="#F8F6F3" stroke="#C4A265" stroke-width="1.5"/><rect x="18" y="22" width="28" height="16" rx="2" fill="#C4A265" opacity="0.12" stroke="#C4A265" stroke-width="0.8"/><circle cx="32" cy="30" r="4" fill="none" stroke="#C4A265" stroke-width="1"/><path d="M22 42h20" stroke="#C4A265" stroke-width="1" opacity="0.5"/></svg>',
    coastal: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="12" y="16" width="40" height="32" rx="3" fill="#F8F6F3" stroke="#0F3460" stroke-width="1.5" opacity="0.6"/><path d="M12 38c6-4 12 0 18-4s12 0 18-4" stroke="#0F3460" stroke-width="1.5" opacity="0.3" fill="none"/><path d="M12 44c6-4 12 0 18-4s12 0 18-4" stroke="#0F3460" stroke-width="1" opacity="0.15" fill="none"/><circle cx="42" cy="22" r="5" fill="#C4A265" opacity="0.3"/></svg>',
    bohemian: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="12" y="16" width="40" height="32" rx="3" fill="#F8F6F3" stroke="#C4A265" stroke-width="1.5"/><g opacity="0.4"><circle cx="22" cy="26" r="4" fill="#C4A265"/><circle cx="34" cy="24" r="3" fill="#0F3460"/><circle cx="44" cy="28" r="3.5" fill="#2C3E50"/><circle cx="28" cy="36" r="3" fill="#C4A265" opacity="0.6"/><circle cx="40" cy="38" r="4" fill="#16213E" opacity="0.5"/></g></svg>',
    single: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="18" y="12" width="28" height="40" rx="4" fill="#e8e4dd"/><rect x="20" y="14" width="24" height="10" rx="3" fill="#C4A265" opacity="0.4"/><rect x="22" y="16" width="20" height="6" rx="2" fill="#fff" opacity="0.5"/></svg>',
    double: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="12" y="12" width="40" height="40" rx="4" fill="#e8e4dd"/><rect x="14" y="14" width="36" height="10" rx="3" fill="#C4A265" opacity="0.4"/><rect x="16" y="16" width="14" height="6" rx="2" fill="#fff" opacity="0.5"/><rect x="34" y="16" width="14" height="6" rx="2" fill="#fff" opacity="0.5"/></svg>',
    queen: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="12" width="48" height="40" rx="4" fill="#e8e4dd"/><rect x="10" y="14" width="44" height="10" rx="3" fill="#C4A265" opacity="0.4"/><rect x="12" y="16" width="18" height="6" rx="2" fill="#fff" opacity="0.5"/><rect x="34" y="16" width="18" height="6" rx="2" fill="#fff" opacity="0.5"/><text x="32" y="44" text-anchor="middle" font-size="8" fill="#C4A265" font-weight="700">Q</text></svg>',
    king: '<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="12" width="56" height="40" rx="4" fill="#e8e4dd"/><rect x="6" y="14" width="52" height="10" rx="3" fill="#C4A265" opacity="0.4"/><rect x="8" y="16" width="22" height="6" rx="2" fill="#fff" opacity="0.5"/><rect x="34" y="16" width="22" height="6" rx="2" fill="#fff" opacity="0.5"/><text x="32" y="44" text-anchor="middle" font-size="8" fill="#C4A265" font-weight="700">K</text></svg>'
  };

  /* ---- Quiz steps definition ---- */
  var steps = [
    {
      id: 'position', type: 'single',
      question: t('How do you sleep?', '\u0643\u064A\u0641 \u062A\u0646\u0627\u0645\u061F'),
      options: [
        { key: 'side',    label: t('Side Sleeper', '\u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628'), desc: t('Curled or straight on your side', '\u0645\u0644\u062A\u0641 \u0623\u0648 \u0645\u0633\u062A\u0642\u064A\u0645 \u0639\u0644\u0649 \u062C\u0627\u0646\u0628\u0643'), icon: 'side' },
        { key: 'back',    label: t('Back Sleeper', '\u0639\u0644\u0649 \u0627\u0644\u0638\u0647\u0631'), desc: t('Face up, arms at your sides', '\u0648\u062C\u0647\u0643 \u0644\u0644\u0623\u0639\u0644\u0649\u060C \u0630\u0631\u0627\u0639\u0627\u0643 \u0639\u0644\u0649 \u062C\u0627\u0646\u0628\u064A\u0643'), icon: 'back' },
        { key: 'stomach', label: t('Stomach Sleeper', '\u0639\u0644\u0649 \u0627\u0644\u0628\u0637\u0646'), desc: t('Face down, hugging the pillow', '\u0648\u062C\u0647\u0643 \u0644\u0644\u0623\u0633\u0641\u0644\u060C \u062A\u062D\u062A\u0636\u0646 \u0627\u0644\u0648\u0633\u0627\u062F\u0629'), icon: 'stomach' },
        { key: 'combo',   label: t('Combination', '\u0645\u062A\u0646\u0648\u0639'), desc: t('You move around all night', '\u062A\u062A\u0642\u0644\u0628 \u0637\u0648\u0627\u0644 \u0627\u0644\u0644\u064A\u0644'), icon: 'combo' }
      ]
    },
    {
      id: 'temperature', type: 'single', gridClass: 'spq-options--three',
      question: t('Are you a hot or cold sleeper?', '\u0647\u0644 \u062A\u0634\u0639\u0631 \u0628\u0627\u0644\u062D\u0631\u0627\u0631\u0629 \u0623\u0648 \u0627\u0644\u0628\u0631\u0648\u062F\u0629 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0646\u0648\u0645\u061F'),
      options: [
        { key: 'hot',     label: t('Hot Sleeper', '\u0623\u0634\u0639\u0631 \u0628\u0627\u0644\u062D\u0631'), desc: t('Often kick off the covers', '\u0623\u0631\u0641\u0633 \u0627\u0644\u063A\u0637\u0627\u0621 \u0643\u062B\u064A\u0631\u0627\u064B'), icon: 'hot' },
        { key: 'cold',    label: t('Cold Sleeper', '\u0623\u0634\u0639\u0631 \u0628\u0627\u0644\u0628\u0631\u062F'), desc: t('Always need extra layers', '\u0623\u062D\u062A\u0627\u062C \u062F\u0627\u0626\u0645\u0627\u064B \u0644\u0637\u0628\u0642\u0627\u062A \u0625\u0636\u0627\u0641\u064A\u0629'), icon: 'cold' },
        { key: 'neutral', label: t('Just Right', '\u0645\u0639\u062A\u062F\u0644'), desc: t('Comfortable most nights', '\u0645\u0631\u062A\u0627\u062D \u0645\u0639\u0638\u0645 \u0627\u0644\u0644\u064A\u0627\u0644\u064A'), icon: 'neutral' }
      ]
    },
    {
      id: 'texture', type: 'single', gridClass: 'spq-options--three',
      question: t('What texture do you prefer?', '\u0645\u0627 \u0627\u0644\u0645\u0644\u0645\u0633 \u0627\u0644\u0630\u064A \u062A\u0641\u0636\u0644\u0647\u061F'),
      options: [
        { key: 'percale', label: t('Crisp & Cool', '\u0645\u0646\u0639\u0634 \u0648\u0628\u0627\u0631\u062F'), desc: t('Like a fresh hotel bed', '\u0645\u062B\u0644 \u0633\u0631\u064A\u0631 \u0641\u0646\u062F\u0642 \u0645\u0646\u0639\u0634'), icon: 'percale' },
        { key: 'sateen',  label: t('Silky & Smooth', '\u0646\u0627\u0639\u0645 \u0648\u062D\u0631\u064A\u0631\u064A'), desc: t('Luxurious, subtle sheen', '\u0641\u0627\u062E\u0631 \u0628\u0644\u0645\u0639\u0629 \u0646\u0627\u0639\u0645\u0629'), icon: 'sateen' },
        { key: 'cozy',    label: t('Soft & Cozy', '\u0646\u0627\u0639\u0645 \u0648\u062F\u0627\u0641\u0626'), desc: t('Warm, brushed feel', '\u0645\u0644\u0645\u0633 \u062F\u0627\u0641\u0626 \u0648\u0645\u0631\u064A\u062D'), icon: 'cozy' }
      ]
    },
    {
      id: 'style', type: 'single',
      question: t("What's your bedroom style?", '\u0645\u0627 \u0647\u0648 \u0637\u0631\u0627\u0632 \u063A\u0631\u0641\u0629 \u0646\u0648\u0645\u0643\u061F'),
      options: [
        { key: 'modern',   label: t('Modern Minimal', '\u0639\u0635\u0631\u064A \u0628\u0633\u064A\u0637'), icon: 'modern' },
        { key: 'classic',  label: t('Classic Luxury', '\u0643\u0644\u0627\u0633\u064A\u0643\u064A \u0641\u0627\u062E\u0631'), icon: 'classic' },
        { key: 'coastal',  label: t('Coastal', '\u0633\u0627\u062D\u0644\u064A'), icon: 'coastal' },
        { key: 'bohemian', label: t('Bohemian', '\u0628\u0648\u0647\u064A\u0645\u064A'), icon: 'bohemian' }
      ]
    },
    {
      id: 'budget', type: 'single',
      question: t("What's your budget for a sheet set?", '\u0645\u0627 \u0647\u064A \u0645\u064A\u0632\u0627\u0646\u064A\u062A\u0643 \u0644\u0637\u0642\u0645 \u0645\u0644\u0627\u0621\u0627\u062A\u061F'),
      options: [
        { key: 'budget',  label: t('Under BHD 25', '\u0623\u0642\u0644 \u0645\u0646 25 \u062F.\u0628.'), desc: t('Great quality basics', '\u0623\u0633\u0627\u0633\u064A\u0627\u062A \u0628\u062C\u0648\u062F\u0629 \u0639\u0627\u0644\u064A\u0629') },
        { key: 'mid',     label: t('BHD 25 \u2013 40', '25 \u2013 40 \u062F.\u0628.'), desc: t('Premium everyday comfort', '\u0631\u0627\u062D\u0629 \u0641\u0627\u062E\u0631\u0629 \u0644\u0644\u064A\u0648\u0645\u064A\u0627\u062A') },
        { key: 'premium',  label: t('BHD 40 \u2013 60', '40 \u2013 60 \u062F.\u0628.'), desc: t('Luxury hotel experience', '\u062A\u062C\u0631\u0628\u0629 \u0641\u0646\u062F\u0642\u064A\u0629 \u0641\u0627\u062E\u0631\u0629') },
        { key: 'luxury',  label: t('Over BHD 60', '\u0623\u0643\u062B\u0631 \u0645\u0646 60 \u062F.\u0628.'), desc: t('The absolute best', '\u0627\u0644\u0623\u0641\u0636\u0644 \u0639\u0644\u0649 \u0627\u0644\u0625\u0637\u0644\u0627\u0642') }
      ]
    },
    {
      id: 'size_allergy', type: 'combo',
      question: t('Almost there! What size is your bed?', '\u0623\u0648\u0634\u0643\u062A \u0639\u0644\u0649 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621! \u0645\u0627 \u062D\u062C\u0645 \u0633\u0631\u064A\u0631\u0643\u061F'),
      sections: [
        {
          id: 'size', type: 'single', gridClass: 'spq-options--sizes',
          options: [
            { key: 'single', label: t('Single', '\u0645\u0641\u0631\u062F'), icon: 'single' },
            { key: 'double', label: t('Double', '\u0645\u0632\u062F\u0648\u062C'), icon: 'double' },
            { key: 'queen',  label: t('Queen', '\u0643\u0648\u064A\u0646'), icon: 'queen' },
            { key: 'king',   label: t('King', '\u0643\u064A\u0646\u063A'), icon: 'king' }
          ]
        },
        {
          id: 'allergies', type: 'multi', subLabel: t('Any allergies or sensitivities?', '\u0647\u0644 \u0644\u062F\u064A\u0643 \u0623\u064A \u062D\u0633\u0627\u0633\u064A\u0629\u061F'),
          options: [
            { key: 'dust',  label: t('Dust Mites', '\u0639\u062B \u0627\u0644\u063A\u0628\u0627\u0631') },
            { key: 'mold',  label: t('Mold', '\u0627\u0644\u0639\u0641\u0646') },
            { key: 'skin',  label: t('Sensitive Skin', '\u0628\u0634\u0631\u0629 \u062D\u0633\u0627\u0633\u0629') },
            { key: 'none',  label: t('None', '\u0644\u0627 \u064A\u0648\u062C\u062F') }
          ]
        }
      ]
    }
  ];

  /* ---- Sleep personas ---- */
  var personas = {
    'hot-percale':   { en: 'The Cool Breeze',       ar: '\u0627\u0644\u0646\u0633\u064A\u0645 \u0627\u0644\u0645\u0646\u0639\u0634', descEn: 'You crave crispness and coolness. Percale sheets in lightweight cotton will keep you comfortable through warm Gulf nights.', descAr: '\u062A\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u0627\u0646\u062A\u0639\u0627\u0634 \u0648\u0627\u0644\u0628\u0631\u0648\u062F\u0629. \u0645\u0644\u0627\u0621\u0627\u062A \u0628\u064A\u0631\u0643\u0627\u0644 \u0627\u0644\u0642\u0637\u0646\u064A\u0629 \u0627\u0644\u062E\u0641\u064A\u0641\u0629 \u0633\u062A\u0628\u0642\u064A\u0643 \u0645\u0631\u062A\u0627\u062D\u0627\u064B \u0641\u064A \u0644\u064A\u0627\u0644\u064A \u0627\u0644\u062E\u0644\u064A\u062C \u0627\u0644\u062F\u0627\u0641\u0626\u0629.', tags: ['percale', 'cooling', 'lightweight'] },
    'hot-sateen':    { en: 'The Silk Breeze',        ar: '\u0627\u0644\u0646\u0633\u064A\u0645 \u0627\u0644\u062D\u0631\u064A\u0631\u064A', descEn: 'You love luxury but need to stay cool. Sateen with temperature-regulating properties is your match.', descAr: '\u062A\u062D\u0628 \u0627\u0644\u0641\u062E\u0627\u0645\u0629 \u0644\u0643\u0646 \u062A\u062D\u062A\u0627\u062C \u0644\u0644\u0628\u0642\u0627\u0621 \u0628\u0627\u0631\u062F\u0627\u064B. \u0633\u0627\u062A\u0627\u0646 \u0645\u0639 \u062E\u0635\u0627\u0626\u0635 \u062A\u0646\u0638\u064A\u0645 \u0627\u0644\u062D\u0631\u0627\u0631\u0629 \u0647\u0648 \u062E\u064A\u0627\u0631\u0643 \u0627\u0644\u0645\u062B\u0627\u0644\u064A.', tags: ['sateen', 'cooling'] },
    'hot-cozy':      { en: 'The Summer Hugger',      ar: '\u0639\u0627\u0634\u0642 \u0627\u0644\u062F\u0641\u0621 \u0627\u0644\u0635\u064A\u0641\u064A', descEn: 'You want softness without the heat. Look for brushed cotton in lighter weights.', descAr: '\u062A\u0631\u064A\u062F \u0627\u0644\u0646\u0639\u0648\u0645\u0629 \u0628\u062F\u0648\u0646 \u0627\u0644\u062D\u0631\u0627\u0631\u0629. \u0627\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u0642\u0637\u0646 \u0627\u0644\u0645\u0635\u0642\u0648\u0644 \u0628\u0623\u0648\u0632\u0627\u0646 \u062E\u0641\u064A\u0641\u0629.', tags: ['lightweight', 'brushed'] },
    'cold-percale':  { en: 'The Layered Classic',    ar: '\u0627\u0644\u0643\u0644\u0627\u0633\u064A\u0643\u064A \u0627\u0644\u0645\u062A\u0639\u062F\u062F', descEn: 'Crisp sheets layered with a cozy comforter. The hotel-bed formula for those who like to bundle up.', descAr: '\u0645\u0644\u0627\u0621\u0627\u062A \u0645\u0646\u0639\u0634\u0629 \u0645\u0639 \u0644\u062D\u0627\u0641 \u062F\u0627\u0641\u0626. \u0645\u0639\u0627\u062F\u0644\u0629 \u0633\u0631\u064A\u0631 \u0627\u0644\u0641\u0646\u062F\u0642 \u0644\u0645\u0646 \u064A\u062D\u0628 \u0627\u0644\u062A\u063A\u0637\u064A\u0629.', tags: ['percale', 'comforter', 'warm'] },
    'cold-sateen':   { en: 'The Silk Cocoon',        ar: '\u0627\u0644\u0634\u0631\u0646\u0642\u0629 \u0627\u0644\u062D\u0631\u064A\u0631\u064A\u0629', descEn: 'Wrap yourself in silky-smooth sateen with a plush duvet. Pure warmth, pure luxury.', descAr: '\u0644\u0641 \u0646\u0641\u0633\u0643 \u0628\u0633\u0627\u062A\u0627\u0646 \u0646\u0627\u0639\u0645 \u0645\u0639 \u0644\u062D\u0627\u0641 \u0641\u0627\u062E\u0631. \u062F\u0641\u0621 \u0648\u0641\u062E\u0627\u0645\u0629.', tags: ['sateen', 'duvet', 'warm'] },
    'cold-cozy':     { en: 'The Cozy Nest',          ar: '\u0627\u0644\u0639\u0634 \u0627\u0644\u062F\u0627\u0641\u0626', descEn: 'Maximum coziness is your priority. Heavyweight brushed sheets with a thick comforter — hibernation mode.', descAr: '\u0627\u0644\u0631\u0627\u062D\u0629 \u0627\u0644\u0642\u0635\u0648\u0649 \u0647\u064A \u0623\u0648\u0644\u0648\u064A\u062A\u0643. \u0645\u0644\u0627\u0621\u0627\u062A \u0633\u0645\u064A\u0643\u0629 \u0645\u0639 \u0644\u062D\u0627\u0641 \u0643\u062B\u064A\u0641 \u2014 \u0648\u0636\u0639 \u0627\u0644\u0633\u0628\u0627\u062A.', tags: ['heavyweight', 'brushed', 'comforter'] },
    'neutral-percale': { en: 'The Hotel Purist',     ar: '\u0639\u0627\u0634\u0642 \u0627\u0644\u0641\u0646\u062F\u0642', descEn: 'Clean, crisp, classic. You appreciate the timeless hotel-bed feel — simple and perfect.', descAr: '\u0646\u0638\u064A\u0641\u060C \u0645\u0646\u0639\u0634\u060C \u0643\u0644\u0627\u0633\u064A\u0643\u064A. \u062A\u0642\u062F\u0631 \u0625\u062D\u0633\u0627\u0633 \u0633\u0631\u064A\u0631 \u0627\u0644\u0641\u0646\u062F\u0642 \u0627\u0644\u062E\u0627\u0644\u062F \u2014 \u0628\u0633\u064A\u0637 \u0648\u0645\u062B\u0627\u0644\u064A.', tags: ['percale', 'classic'] },
    'neutral-sateen':  { en: 'The Silk Dreamer',     ar: '\u0627\u0644\u062D\u0627\u0644\u0645 \u0627\u0644\u062D\u0631\u064A\u0631\u064A', descEn: 'Smooth, luminous sateen for a bedroom that feels indulgent every single night.', descAr: '\u0633\u0627\u062A\u0627\u0646 \u0646\u0627\u0639\u0645 \u0648\u0645\u0636\u064A\u0621 \u0644\u063A\u0631\u0641\u0629 \u0646\u0648\u0645 \u0641\u0627\u062E\u0631\u0629 \u0643\u0644 \u0644\u064A\u0644\u0629.', tags: ['sateen', 'luxury'] },
    'neutral-cozy':    { en: 'The Cloud Drifter',    ar: '\u0627\u0644\u0637\u0627\u0641\u064A \u0639\u0644\u0649 \u0627\u0644\u0633\u062D\u0627\u0628', descEn: 'Pillowy softness is your love language. Brushed fabrics, fluffy pillows, and gentle textures.', descAr: '\u0627\u0644\u0646\u0639\u0648\u0645\u0629 \u0627\u0644\u0633\u062D\u0627\u0628\u064A\u0629 \u0647\u064A \u0644\u063A\u0629 \u062D\u0628\u0643. \u0623\u0642\u0645\u0634\u0629 \u0645\u0635\u0642\u0648\u0644\u0629\u060C \u0648\u0633\u0627\u0626\u062F \u0645\u0646\u0641\u0648\u0634\u0629\u060C \u0648\u0645\u0644\u0627\u0645\u0633 \u0644\u0637\u064A\u0641\u0629.', tags: ['brushed', 'soft', 'pillows'] }
  };

  /* ---- State ---- */
  var state = { current: 0, answers: {}, multiSelections: {} };

  /* ---- Helpers ---- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function html(tag, cls, inner) { var el = document.createElement(tag); if (cls) el.className = cls; if (inner !== undefined) { if (typeof inner === 'string') el.innerHTML = inner; else el.appendChild(inner); } return el; }

  /* ---- Render progress ---- */
  function renderProgress() {
    var pct = Math.round(((state.current) / steps.length) * 100);
    if (state.current >= steps.length) pct = 100;
    var bar = $('.spq-progress__fill', root);
    var txt = $('.spq-progress__text', root);
    if (bar) bar.style.width = pct + '%';
    if (txt) txt.textContent = pct + '%';
  }

  /* ---- Render a single-select option card ---- */
  function renderCard(opt, stepId, selected) {
    var card = html('div', 'spq-card' + (selected === opt.key ? ' is-selected' : ''));
    card.setAttribute('data-key', opt.key);
    card.setAttribute('role', 'button');
    card.setAttribute('tabindex', '0');
    card.setAttribute('aria-pressed', selected === opt.key ? 'true' : 'false');
    if (opt.icon && icons[opt.icon]) {
      var iconDiv = html('div', 'spq-card__icon', icons[opt.icon]);
      card.appendChild(iconDiv);
    }
    var lbl = html('div', 'spq-card__label', opt.label);
    card.appendChild(lbl);
    if (opt.desc) {
      var d = html('div', 'spq-card__desc', opt.desc);
      card.appendChild(d);
    }
    card.addEventListener('click', function () { selectOption(stepId, opt.key); });
    card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOption(stepId, opt.key); } });
    return card;
  }

  /* ---- Render a checkbox card ---- */
  function renderCheckCard(opt, sectionId) {
    var sels = state.multiSelections[sectionId] || [];
    var isOn = sels.indexOf(opt.key) >= 0;
    var card = html('div', 'spq-card spq-card--check' + (isOn ? ' is-selected' : ''));
    card.setAttribute('data-key', opt.key);
    card.setAttribute('role', 'checkbox');
    card.setAttribute('tabindex', '0');
    card.setAttribute('aria-checked', isOn ? 'true' : 'false');
    var chk = html('div', 'spq-card__check');
    card.appendChild(chk);
    var lbl = html('div', 'spq-card__label', opt.label);
    card.appendChild(lbl);
    card.addEventListener('click', function () { toggleMulti(sectionId, opt.key); });
    card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleMulti(sectionId, opt.key); } });
    return card;
  }

  /* ---- Select single option ---- */
  function selectOption(stepId, key) {
    state.answers[stepId] = key;
    renderStep();
  }

  /* ---- Toggle multi option ---- */
  function toggleMulti(sectionId, key) {
    var sels = state.multiSelections[sectionId] || [];
    if (key === 'none') {
      sels = sels.indexOf('none') >= 0 ? [] : ['none'];
    } else {
      sels = sels.filter(function (k) { return k !== 'none'; });
      var idx = sels.indexOf(key);
      if (idx >= 0) sels.splice(idx, 1); else sels.push(key);
    }
    state.multiSelections[sectionId] = sels;
    state.answers[sectionId] = sels.join(',') || 'none';
    renderStep();
  }

  /* ---- Can proceed? ---- */
  function canProceed() {
    var step = steps[state.current];
    if (!step) return false;
    if (step.type === 'combo') {
      return step.sections.every(function (sec) {
        if (sec.type === 'single') return !!state.answers[sec.id];
        return true; // multi selections are optional
      });
    }
    return !!state.answers[step.id];
  }

  /* ---- Render current step ---- */
  function renderStep() {
    var container = $('.spq-steps', root);
    if (!container) return;
    container.innerHTML = '';
    renderProgress();

    if (state.current >= steps.length) { renderResults(); return; }

    var step = steps[state.current];
    var wrap = html('div', 'spq-step is-active');

    var q = html('h2', 'spq-step__question', step.question);
    wrap.appendChild(q);

    if (step.type === 'single') {
      var grid = html('div', 'spq-options' + (step.gridClass ? ' ' + step.gridClass : ''));
      step.options.forEach(function (opt) { grid.appendChild(renderCard(opt, step.id, state.answers[step.id])); });
      wrap.appendChild(grid);
    } else if (step.type === 'combo') {
      step.sections.forEach(function (sec) {
        if (sec.subLabel) {
          var sub = html('h3', 'spq-step__question', sec.subLabel);
          sub.style.fontSize = '1rem';
          sub.style.marginTop = '1.5rem';
          wrap.appendChild(sub);
        }
        var grid = html('div', 'spq-options' + (sec.gridClass ? ' ' + sec.gridClass : ''));
        if (sec.type === 'single') {
          sec.options.forEach(function (opt) { grid.appendChild(renderCard(opt, sec.id, state.answers[sec.id])); });
        } else if (sec.type === 'multi') {
          sec.options.forEach(function (opt) { grid.appendChild(renderCheckCard(opt, sec.id)); });
        }
        wrap.appendChild(grid);
      });
    }

    /* Nav buttons */
    var nav = html('div', 'spq-nav');
    if (state.current > 0) {
      var prevBtn = html('button', 'spq-btn spq-btn--secondary', isAr ? '<span style="margin-' + (isAr ? 'left' : 'right') + ':4px">\u2192</span> ' + '\u0627\u0644\u0633\u0627\u0628\u0642' : '\u2190 ' + 'Back');
      prevBtn.addEventListener('click', function () { state.current--; renderStep(); });
      nav.appendChild(prevBtn);
    } else {
      nav.appendChild(html('div'));
    }

    var isLast = state.current === steps.length - 1;
    var nextLabel = isLast ? t('See My Results', '\u0627\u0639\u0631\u0636 \u0646\u062A\u0627\u0626\u062C\u064A') : t('Next', '\u0627\u0644\u062A\u0627\u0644\u064A');
    var arrow = isLast ? '' : (isAr ? ' <span style="margin-right:4px">\u2190</span>' : ' <span style="margin-left:4px">\u2192</span>');
    var nextBtn = html('button', 'spq-btn spq-btn--primary', nextLabel + arrow);
    nextBtn.disabled = !canProceed();
    nextBtn.addEventListener('click', function () {
      if (!canProceed()) return;
      state.current++;
      renderStep();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    nav.appendChild(nextBtn);
    wrap.appendChild(nav);
    container.appendChild(wrap);
  }

  /* ---- Recommendation engine ---- */
  function getPersona() {
    var temp = state.answers.temperature || 'neutral';
    var tex = state.answers.texture || 'percale';
    var key = temp + '-' + tex;
    return personas[key] || personas['neutral-percale'];
  }

  function getTraits() {
    var traits = [];
    var a = state.answers;

    var posMap = { side: t('Side Sleeper', '\u0646\u0627\u0626\u0645 \u0639\u0644\u0649 \u0627\u0644\u062C\u0627\u0646\u0628'), back: t('Back Sleeper', '\u0646\u0627\u0626\u0645 \u0639\u0644\u0649 \u0627\u0644\u0638\u0647\u0631'), stomach: t('Stomach Sleeper', '\u0646\u0627\u0626\u0645 \u0639\u0644\u0649 \u0627\u0644\u0628\u0637\u0646'), combo: t('Combination Sleeper', '\u0646\u0627\u0626\u0645 \u0645\u062A\u0646\u0648\u0639') };
    if (a.position) traits.push(posMap[a.position] || a.position);

    var tempMap = { hot: t('Hot Sleeper', '\u062D\u0631\u0627\u0631\u064A'), cold: t('Cold Sleeper', '\u0628\u0627\u0631\u062F'), neutral: t('Balanced Temp', '\u062D\u0631\u0627\u0631\u0629 \u0645\u0639\u062A\u062F\u0644\u0629') };
    if (a.temperature) traits.push(tempMap[a.temperature] || a.temperature);

    var texMap = { percale: t('Percale Lover', '\u0645\u062D\u0628 \u0627\u0644\u0628\u064A\u0631\u0643\u0627\u0644'), sateen: t('Sateen Lover', '\u0645\u062D\u0628 \u0627\u0644\u0633\u0627\u062A\u0627\u0646'), cozy: t('Cozy Lover', '\u0645\u062D\u0628 \u0627\u0644\u062F\u0641\u0621') };
    if (a.texture) traits.push(texMap[a.texture] || a.texture);

    if (a.size) {
      var sizeMap = { single: t('Single Bed', '\u0633\u0631\u064A\u0631 \u0645\u0641\u0631\u062F'), double: t('Double Bed', '\u0633\u0631\u064A\u0631 \u0645\u0632\u062F\u0648\u062C'), queen: t('Queen Bed', '\u0633\u0631\u064A\u0631 \u0643\u0648\u064A\u0646'), king: t('King Bed', '\u0633\u0631\u064A\u0631 \u0643\u064A\u0646\u063A') };
      traits.push(sizeMap[a.size] || a.size);
    }
    return traits;
  }

  function getCollectionHandles() {
    var handles = [];
    var a = state.answers;

    /* Texture → primary collection */
    if (a.texture === 'percale') handles.push('sheet-sets'); // percale sheets
    else if (a.texture === 'sateen') handles.push('sheet-sets');
    else handles.push('sheet-sets');

    /* Temperature → additional */
    if (a.temperature === 'hot') handles.push('pillows'); // cooling pillows
    if (a.temperature === 'cold') handles.push('comforters-duvets');

    /* Always suggest towels for complete set */
    handles.push('towel-sets');

    /* Budget → value collection */
    if (a.budget === 'budget') handles.push('under-bhd-30');
    else if (a.budget === 'luxury') handles.push('best-sellers');

    return handles.filter(function (v, i, arr) { return arr.indexOf(v) === i; });
  }

  /* ---- Fetch products from Shopify AJAX API ---- */
  function fetchProducts(handles, callback) {
    var products = [];
    var done = 0;
    if (handles.length === 0) { callback([]); return; }

    handles.forEach(function (handle) {
      var url = '/collections/' + handle + '/products.json?limit=4';
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url);
      xhr.onload = function () {
        done++;
        if (xhr.status === 200) {
          try {
            var data = JSON.parse(xhr.responseText);
            if (data.products) products = products.concat(data.products);
          } catch (e) { /* ignore parse errors */ }
        }
        if (done === handles.length) {
          /* Deduplicate by ID */
          var seen = {};
          var unique = [];
          products.forEach(function (p) {
            if (!seen[p.id]) { seen[p.id] = true; unique.push(p); }
          });
          callback(unique.slice(0, 8));
        }
      };
      xhr.onerror = function () { done++; if (done === handles.length) callback(products.slice(0, 8)); };
      xhr.send();
    });
  }

  /* ---- Render results ---- */
  function renderResults() {
    var container = $('.spq-steps', root);
    container.innerHTML = '';

    var persona = getPersona();
    var traits = getTraits();

    /* Profile card */
    var profile = html('div', 'spq-profile');
    var badge = html('div', 'spq-profile__badge', t('Your Sleep Profile', '\u0645\u0644\u0641 \u0646\u0648\u0645\u0643 \u0627\u0644\u0634\u062E\u0635\u064A'));
    profile.appendChild(badge);
    var name = html('h2', 'spq-profile__name', isAr ? persona.ar : persona.en);
    profile.appendChild(name);
    var desc = html('p', 'spq-profile__desc', isAr ? persona.descAr : persona.descEn);
    profile.appendChild(desc);

    var traitsDiv = html('div', 'spq-profile__traits');
    traits.forEach(function (tr) {
      var span = html('span', 'spq-profile__trait', tr);
      traitsDiv.appendChild(span);
    });
    profile.appendChild(traitsDiv);
    container.appendChild(profile);

    /* Loading state for products */
    var recsWrap = html('div', 'spq-recs');
    var recsTitle = html('h3', 'spq-recs__title', t('Recommended for You', '\u0645\u0648\u0635\u0649 \u0628\u0647 \u0644\u0643'));
    recsWrap.appendChild(recsTitle);

    var loadingDiv = html('div', 'spq-loading', '<div class="spq-loading__spinner"></div><div class="spq-loading__text">' + t('Finding your perfect match...', '\u0646\u0628\u062D\u062B \u0639\u0646 \u0627\u0644\u062E\u064A\u0627\u0631 \u0627\u0644\u0645\u062B\u0627\u0644\u064A \u0644\u0643...') + '</div>');
    recsWrap.appendChild(loadingDiv);
    container.appendChild(recsWrap);

    /* Fetch products */
    var handles = getCollectionHandles();
    fetchProducts(handles, function (products) {
      loadingDiv.remove();

      if (products.length === 0) {
        /* Empty state — link to collections */
        var empty = html('div', 'spq-empty');
        empty.innerHTML = '<div class="spq-empty__icon">' + icons.percale + '</div>' +
          '<p class="spq-empty__text">' + t('We\'re stocking up! Browse our collections while we add your perfect products.', '\u0646\u062D\u0646 \u0646\u062C\u0647\u0632 \u0627\u0644\u0645\u0646\u062A\u062C\u0627\u062A! \u062A\u0635\u0641\u062D \u0645\u062C\u0645\u0648\u0639\u0627\u062A\u0646\u0627 \u0628\u064A\u0646\u0645\u0627 \u0646\u0636\u064A\u0641 \u0627\u0644\u0645\u0646\u062A\u062C\u0627\u062A \u0627\u0644\u0645\u062B\u0627\u0644\u064A\u0629 \u0644\u0643.') + '</p>' +
          '<a href="/collections" class="spq-empty__link">' + t('Shop All Collections', '\u062A\u0633\u0648\u0642 \u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0627\u062A') + '</a>';
        recsWrap.appendChild(empty);
      } else {
        /* Product grid */
        var grid = html('div', 'spq-products');
        products.forEach(function (p) {
          var card = html('div', 'spq-product');
          var img = p.images && p.images[0] ? p.images[0].src : '';
          if (img) {
            var imgEl = document.createElement('img');
            imgEl.className = 'spq-product__img';
            imgEl.src = img.replace(/\.([a-z]+)\?/, '_400x.$1?');
            imgEl.alt = p.title;
            imgEl.loading = 'lazy';
            card.appendChild(imgEl);
          } else {
            var placeholder = html('div', 'spq-product__img');
            placeholder.style.display = 'flex';
            placeholder.style.alignItems = 'center';
            placeholder.style.justifyContent = 'center';
            placeholder.innerHTML = icons.percale;
            card.appendChild(placeholder);
          }

          var body = html('div', 'spq-product__body');
          var nameEl = html('h4', 'spq-product__name', p.title);
          body.appendChild(nameEl);

          var priceStr = '';
          var variant = p.variants && p.variants[0];
          if (variant) {
            var price = parseFloat(variant.price);
            priceStr = (isAr ? price.toFixed(3) + ' \u062F.\u0628.' : 'BHD ' + price.toFixed(3));
          }
          var priceEl = html('div', 'spq-product__price', priceStr);
          body.appendChild(priceEl);

          var btn = html('button', 'spq-product__btn', t('Add to Cart', '\u0623\u0636\u0641 \u0644\u0644\u0633\u0644\u0629'));
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            if (variant) addToCart(variant.id, btn);
          });
          body.appendChild(btn);
          card.appendChild(body);
          grid.appendChild(card);
        });
        recsWrap.appendChild(grid);

        /* Bundle CTA */
        if (products.length >= 2) {
          var total = 0;
          products.slice(0, 4).forEach(function (p) {
            if (p.variants && p.variants[0]) total += parseFloat(p.variants[0].price);
          });
          var bundle = html('div', 'spq-bundle');
          var bundlePrice = html('div', 'spq-bundle__price', isAr ? total.toFixed(3) + ' \u062F.\u0628.' : 'BHD ' + total.toFixed(3));
          bundle.appendChild(bundlePrice);
          var bundleLabel = html('div', 'spq-bundle__label', t('Complete bundle price (up to ' + Math.min(products.length, 4) + ' items)', '\u0633\u0639\u0631 \u0627\u0644\u062D\u0632\u0645\u0629 \u0627\u0644\u0643\u0627\u0645\u0644\u0629 (\u062D\u062A\u0649 ' + Math.min(products.length, 4) + ' \u0645\u0646\u062A\u062C\u0627\u062A)'));
          bundle.appendChild(bundleLabel);
          var bundleBtn = html('button', 'spq-btn spq-btn--primary spq-bundle__btn', t('Add Bundle to Cart', '\u0623\u0636\u0641 \u0627\u0644\u062D\u0632\u0645\u0629 \u0644\u0644\u0633\u0644\u0629'));
          bundleBtn.addEventListener('click', function () { addBundleToCart(products.slice(0, 4), bundleBtn); });
          bundle.appendChild(bundleBtn);
          recsWrap.appendChild(bundle);
        }
      }

      /* Actions row */
      var actions = html('div', 'spq-actions');
      var retakeBtn = html('button', 'spq-btn spq-btn--secondary', t('Retake Quiz', '\u0623\u0639\u062F \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631'));
      retakeBtn.addEventListener('click', function () {
        state.current = 0;
        state.answers = {};
        state.multiSelections = {};
        renderStep();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      actions.appendChild(retakeBtn);

      var shareBtn = html('button', 'spq-btn spq-btn--secondary', t('Share on WhatsApp', '\u0634\u0627\u0631\u0643 \u0639\u0628\u0631 \u0648\u0627\u062A\u0633\u0627\u0628'));
      shareBtn.addEventListener('click', function () {
        var pName = isAr ? persona.ar : persona.en;
        var msg = t(
          'I just took the WestPoint Home Sleep Profiler Quiz! My profile: ' + pName + '. Take yours: ',
          '\u0623\u062E\u0630\u062A \u0644\u0644\u062A\u0648 \u0627\u062E\u062A\u0628\u0627\u0631 \u0627\u0644\u0646\u0648\u0645 \u0645\u0646 \u0648\u064A\u0633\u062A \u0628\u0648\u064A\u0646\u062A \u0647\u0648\u0645! \u0645\u0644\u0641\u064A: ' + pName + '. \u062C\u0631\u0628 \u0627\u062E\u062A\u0628\u0627\u0631\u0643: '
        );
        window.open('https://wa.me/?text=' + encodeURIComponent(msg + window.location.href), '_blank');
      });
      actions.appendChild(shareBtn);
      container.appendChild(actions);
    });

    renderProgress();
  }

  /* ---- Add to cart (Shopify AJAX API) ---- */
  function addToCart(variantId, btn) {
    var origText = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = t('Adding...', '\u062C\u0627\u0631\u064A \u0627\u0644\u0625\u0636\u0627\u0641\u0629...');

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function () {
      if (xhr.status === 200) {
        btn.innerHTML = t('Added!', '\u062A\u0645\u062A \u0627\u0644\u0625\u0636\u0627\u0641\u0629!');
        btn.style.background = '#2d7a3a';
        setTimeout(function () { btn.innerHTML = origText; btn.disabled = false; btn.style.background = ''; }, 2000);
      } else {
        btn.innerHTML = origText;
        btn.disabled = false;
      }
    };
    xhr.onerror = function () { btn.innerHTML = origText; btn.disabled = false; };
    xhr.send(JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }));
  }

  function addBundleToCart(products, btn) {
    var items = [];
    products.forEach(function (p) {
      if (p.variants && p.variants[0]) items.push({ id: p.variants[0].id, quantity: 1 });
    });
    if (items.length === 0) return;

    var origText = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = t('Adding bundle...', '\u062C\u0627\u0631\u064A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u062D\u0632\u0645\u0629...');

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function () {
      if (xhr.status === 200) {
        btn.innerHTML = t('Bundle Added!', '\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u062D\u0632\u0645\u0629!');
        btn.style.background = '#2d7a3a';
        setTimeout(function () {
          window.location.href = '/cart';
        }, 1500);
      } else {
        btn.innerHTML = origText;
        btn.disabled = false;
      }
    };
    xhr.onerror = function () { btn.innerHTML = origText; btn.disabled = false; };
    xhr.send(JSON.stringify({ items: items }));
  }

  /* ---- Save quiz results to customer metafield (if logged in) ---- */
  function saveToCustomer() {
    /* Shopify AJAX API doesn't support customer metafields from storefront.
       We'll store in localStorage for returning visitors and let Shopify Flow
       handle tagging via order notes if they purchase. */
    try {
      var data = {
        persona: getPersona().en,
        answers: state.answers,
        date: new Date().toISOString()
      };
      localStorage.setItem('wph_sleep_profile', JSON.stringify(data));
    } catch (e) { /* storage unavailable */ }
  }

  /* ---- Init ---- */
  function init() {
    /* Build shell */
    root.innerHTML = '';
    root.className = 'spq';

    /* Progress bar */
    var progress = html('div', 'spq-progress');
    progress.innerHTML = '<div class="spq-progress__bar"><div class="spq-progress__fill" style="width:0%"></div></div><div class="spq-progress__text">0%</div>';
    root.appendChild(progress);

    /* Header */
    var header = html('div', 'spq-header');
    header.innerHTML = '<h1 class="spq-header__title">' + t('Find Your Perfect Bedding', '\u0627\u0643\u062A\u0634\u0641 \u0623\u063A\u0637\u064A\u0629 \u0627\u0644\u0633\u0631\u064A\u0631 \u0627\u0644\u0645\u062B\u0627\u0644\u064A\u0629') + '</h1><p class="spq-header__sub">' + t('Answer 6 quick questions and we\'ll match you with your ideal bedding.', '\u0623\u062C\u0628 \u0639\u0646 6 \u0623\u0633\u0626\u0644\u0629 \u0633\u0631\u064A\u0639\u0629 \u0648\u0633\u0646\u0637\u0627\u0628\u0642\u0643 \u0645\u0639 \u0623\u063A\u0637\u064A\u0629 \u0627\u0644\u0633\u0631\u064A\u0631 \u0627\u0644\u0645\u062B\u0627\u0644\u064A\u0629 \u0644\u0643.') + '</p>';
    root.appendChild(header);

    /* Steps container */
    var stepsDiv = html('div', 'spq-steps');
    root.appendChild(stepsDiv);

    renderStep();
  }

  /* ---- Run ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
